<template>
  <section class="content-section">
    <div class="content-inner">
      <div class="section-title">
        <div class="title-main">CORE ADVANTAGES</div>
        <div class="title-sub">核心优势 <span class="slash">//</span> FEATURES</div>
      </div>

      <div class="feature-grid">
        <div
          v-for="feature in features"
          :key="feature.id"
          class="tech-card"
          :style="{ '--accent': feature.accent }"
        >
          <div class="card-bg-num">{{ feature.id }}</div>
          <div class="card-header">
            <div class="card-icon">
              <!-- Database icon -->
              <svg v-if="feature.icon === 'database'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <ellipse cx="12" cy="5" rx="9" ry="3"/>
                <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
                <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3"/>
              </svg>
              <!-- Bolt icon -->
              <svg v-if="feature.icon === 'bolt'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
              </svg>
              <!-- Gear icon -->
              <svg v-if="feature.icon === 'gear'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="3"/>
                <path d="M12 1v6m0 6v6M5.6 5.6l4.2 4.2m4.2 4.2l4.2 4.2M1 12h6m6 0h6M5.6 18.4l4.2-4.2m4.2-4.2l4.2-4.2"/>
              </svg>
            </div>
            <h3>{{ feature.title }}</h3>
          </div>
          <p>{{ feature.description }}</p>
          <div class="card-line"></div>
          <div class="card-footer">{{ feature.footer }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { features } from '../data/data.js'
</script>
